module.exports = __webpack_public_path__ + "static/media/favicon.b006fe71.ico";